import { render, staticRenderFns } from "./NoProducts.vue?vue&type=template&id=9adf0ef8&"
import script from "./NoProducts.vue?vue&type=script&lang=js&"
export * from "./NoProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports